import React, { useContext, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import * as Yup from "yup";
import { Form, Formik } from "formik";

import { SettingsContext } from "../../contexts";
import { ValidationHelper } from "../../helpers";
import { FieldGroup, SubmitButton } from "../../components";
import { queryParam } from "../../core/utils/queryParam.js";

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const LoginForm = ({ onSubmit, retailError }) => {
  const recaptchaRef = useRef();
  const { isRetailCircle } = useContext(SettingsContext);
  const validationSchema = Yup.object({
    ...ValidationHelper.requiredRules(["email"]),
    password: Yup.string().required("This field is required."),
  });

  const onHanldeSubmit = async (data) => {
    const token = await recaptchaRef.current.executeAsync("signin");
    onSubmit({ ...data, recaptcha: token });
  };
  

  return (
    <Formik
      initialValues={{ email: queryParam("email") || "", password: "" }}
      validationSchema={validationSchema}
      onSubmit={onHanldeSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <ReCAPTCHA
            ref={recaptchaRef}
            size="invisible"
            sitekey={RECAPTCHA_SITE_KEY}
          />
          <FieldGroup placeholder="Email" type="email" name="email" />

          <FieldGroup placeholder="Password" type="password" name="password" />
          {retailError && <div className="text-error error">{retailError}</div>}

          <div className="action-row mt-4 mb-4">
            <SubmitButton
              label={isRetailCircle ? "Confirm" : "Log In"}
              isSubmitting={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
